<template>
    <!-- <div :class="['alt-engraving__design-modal',{'active': showModal}]"> -->
    <div class="alt-engraving__design-modal engraving__modal-customize"  @click="closeModalOnClickOutside">
        <div class="alt-engraving__modal-content" @click.stop>
            <h4 class="alt-engraving__modal-title">Engrave your design</h4>
            <div class="alt-engraving__modal-description">
                <p>Choose your font style. Write a name or blessing. Add symbol with a click.</p>
                <p class="alt-engraving__note">*{{ engravingSettings.engravingNote }}</p>
            </div>
            <div class="alt-engraving__modal-preview">
                <span class="alt-elegant-font" v-html="previewContent"></span>
            </div>
            <div class="alt-engraving__select-font alt-engraving__modal-step">
                <span class="alt-engraving__step-title">STEP 1: Choose your font style</span>
                <div class="alt-engraving__fonts">
                    <span
                        v-for="font in fonts"
                        :data-font="font.class"
                        :data-fontname="font.label"
                        :key="font.name"
                        @click="selectFonts(font.name)"
                        :class="[font.class, { active: selectedFont === font.name }]">
                        {{ font.label }}
                    </span>
                </div>
            </div>
            <div class="alt-engraving__text-editor alt-engraving__modal-step">
                <span class="alt-engraving__step-title">STEP 2: Write a name or blessing</span>
                <div class="alt-engraving__input-editor">
                    <div class="alt-engraving__input-field customize">
                        <div class="alt-engraving__input-container namenecklace-form__input--inner">
                            <input type="text" @focus="focusInput" @blur="blurInput" @keyup="changeValueInput" id="alt-engraving__input" name="alt-engraving__input" class="alt-engraving__input alt-elegant-font">
                            <span class="namenecklace-form__input--symbols" @click="toggleSymbols">
                            <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.5 2.14953C9.85489 2.14953 11.1794 2.5513 12.3059 3.30404C13.4325 4.05678 14.3105 5.12668 14.829 6.37844C15.3475 7.6302 15.4832 9.0076 15.2188 10.3365C14.9545 11.6653 14.3021 12.886 13.344 13.844C12.386 14.8021 11.1653 15.4545 9.83646 15.7188C8.5076 15.9832 7.1302 15.8475 5.87844 15.329C4.62668 14.8105 3.55678 13.9325 2.80404 12.8059C2.0513 11.6794 1.64953 10.3549 1.64953 9C1.65164 7.18379 2.37406 5.44257 3.65832 4.15832C4.94257 2.87406 6.68379 2.15164 8.5 2.14953ZM8.5 1.03125C6.92393 1.03125 5.38325 1.49861 4.0728 2.37423C2.76235 3.24984 1.74097 4.49439 1.13784 5.95049C0.534699 7.40659 0.376892 9.00884 0.684367 10.5546C0.991843 12.1004 1.75079 13.5203 2.86524 14.6348C3.97969 15.7492 5.39959 16.5082 6.94537 16.8156C8.49116 17.1231 10.0934 16.9653 11.5495 16.3622C13.0056 15.759 14.2502 14.7377 15.1258 13.4272C16.0014 12.1167 16.4688 10.5761 16.4688 9C16.4688 6.88656 15.6292 4.85967 14.1348 3.36524C12.6403 1.87081 10.6134 1.03125 8.5 1.03125Z"
                                            fill="#9D9D9D" />
                                        <path
                                            d="M8.5 13.4439C7.7786 13.4325 7.06725 13.2729 6.41015 12.975C5.75306 12.677 5.16424 12.2472 4.68031 11.712C4.62704 11.6545 4.58671 11.5862 4.56201 11.5117C4.53732 11.4373 4.52884 11.3584 4.53714 11.2804C4.54545 11.2024 4.57034 11.1271 4.61015 11.0595C4.64996 10.9919 4.70377 10.9337 4.76797 10.8886H4.7839C4.89285 10.8134 5.02517 10.7798 5.1568 10.7939C5.28843 10.8081 5.4106 10.869 5.50109 10.9656C5.89581 11.4027 6.37888 11.7509 6.91833 11.9872C7.45777 12.2235 8.04126 12.3425 8.63015 12.3363C9.17537 12.309 9.70979 12.1741 10.2026 11.9393C10.6954 11.7046 11.1369 11.3745 11.5016 10.9683C11.5917 10.8712 11.714 10.8099 11.8458 10.7957C11.9775 10.7816 12.11 10.8155 12.2187 10.8913H12.2347C12.2988 10.9357 12.3526 10.9933 12.3926 11.0602C12.4327 11.1271 12.4579 11.2018 12.4667 11.2792C12.4755 11.3567 12.4677 11.4352 12.4437 11.5093C12.4197 11.5835 12.3801 11.6517 12.3277 11.7094C11.864 12.2277 11.3012 12.6479 10.6726 12.9454C10.0439 13.2428 9.36215 13.4114 8.66734 13.4413C8.6089 13.4439 8.55312 13.4439 8.5 13.4439Z"
                                            fill="#9D9D9D" />
                                        <path
                                            d="M4.5315 6.8883C4.5315 7.50591 5.03218 8.00658 5.64979 8.00658C6.2674 8.00658 6.76807 7.50591 6.76807 6.8883C6.76807 6.27069 6.2674 5.77002 5.64979 5.77002C5.03218 5.77002 4.5315 6.27069 4.5315 6.8883Z"
                                            fill="#9D9D9D" />
                                        <path
                                            d="M10.2319 6.8883C10.2319 7.50591 10.7326 8.00658 11.3502 8.00658C11.9678 8.00658 12.4685 7.50591 12.4685 6.8883C12.4685 6.27069 11.9678 5.77002 11.3502 5.77002C10.7326 5.77002 10.2319 6.27069 10.2319 6.8883Z"
                                            fill="#9D9D9D" />
                            </svg>
                            </span>
                            <div class="namenecklace-form__input--maxlength">
                                <span class="text-remaider">{{ inputLength }}</span>/{{ maxlength }}
                                <!-- {{ currentMaxLength }} -->
                            </div>
                        </div>
                        <div class="nameneckale-symbols" :class="{ active: showSymbolsPanel }" >
                            <span 
                                v-for="(icon, index) in icons" 
                                :key="index" 
                                @click="insertSymbol(icon.value)"
                                :data-value="icon.value"
                            >
                                {{ icon.value }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <span class="alt-engraving__character-count" v-html="charactercount"></span> -->
            <div class="alt-engraving__confirm-modal">
                <a href="#" @click="confirm_engraving_design_modal($event)" class="alt-engraving__confirm-button disabled" data-item="1">Done</a>
            </div>
            <span @click="closepopup_engraving_design_modal" class="alt-engraving__modal-close">×</span>
        </div>
    </div>
</template>
<style lang="scss">
    @import "@/assets/scss/components/product/_engraving_modal.scss";
    @import "@/assets/scss/components/product/_namenecklace.scss";
</style>

<script lang="ts" setup >
import {defineProps, ref, computed} from 'vue';
    const emit = defineEmits(['update:value','customiseUpdateFont','updateStatus', 'close', 'sendEngravingData']);
    const props = defineProps<{
        value: string,
        keyModal: number,
        maxlength: number,
        engravingSettings: {
            engravingNote:string;
            limitCharacter: string;
            limitElegantCharacter:string;
            limitCursiveCharacter:string;
        };
    }>();
    const engravingSettings = computed(() => props.engravingSettings);
    const fontArr = ['alt-chinese-font', 'alt-cursive-font', 'alt-elegant-font'];
    const previewContent = ref('Your Engraving');
    const charactercount = ref(`${engravingSettings.value.limitElegantCharacter}/${engravingSettings.value.limitElegantCharacter} characters left`);
    const selectedFont = ref('alt-elegant-font');
    const validate: { [key: string]: string } = {
        "alt-chinese-font" : engravingSettings.value.limitCharacter,
        "alt-elegant-font" : engravingSettings.value.limitElegantCharacter,
        "alt-cursive-font" : engravingSettings.value.limitCursiveCharacter,
    }
    // New values
    const inputValue = ref('')
    const showSymbolsPanel = ref(false)
    const currentMaxLength = ref(10)
    const inputLength = computed(() => inputValue.value.length)

    const localValue = computed({
        get() {
            return props.value;
        },
        set(newValue) {
            emit('update:value', newValue);
        }
    });
    const fonts = [
        { name: 'alt-elegant-font', class: 'alt-elegant-font', label: 'Elegant' },
        { name: 'alt-cursive-font', class: 'alt-cursive-font', label: 'Cursive' },
        { name: 'alt-chinese-font', class: 'alt-chinese-font', label: 'Chinese' },
    ]

    const icons = [
        { value: '♡', src: '/single-product/heart-icon.webp', alt: 'heart icon' },
        { value: '☆', src: '/single-product/star-icon.webp', alt: 'star icon' },
        { value: '✞​', src: '/single-product/cross-icon.webp', alt: 'cross icon' },
        { value: '∞', src: '/single-product/infinity-icon.webp', alt: 'infinity icon' },
    ]
    const closepopup_engraving_design_modal = () => {
        emit('close')
    };
    const closeModalOnClickOutside = () => {
        emit('close');
    };

    const confirm_engraving_design_modal = (event: Event) => {
        event.preventDefault()
        const engravingSelected = document.querySelector('.alt-engraving__design-modal') as HTMLElement | null;
        const engravingInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const add_to_cart = document.querySelector('.add-to-cart-btn-modal') as HTMLElement | null;
        const fontSelected = document.querySelector(".alt-engraving__fonts .active") as HTMLElement;
        if (engravingSelected && engravingInput) {
            localValue.value = engravingInput.value;
            // add_to_cart.classList.add('active');
            // engravingSelected.classList.remove('active');
            emit('close')
            emit('updateStatus');
            emit('sendEngravingData', {
                text: engravingInput.value,
                font: fontSelected ? fontSelected.getAttribute("data-font") : '',
            });
        }
    };

    const focusInput = () => {
        const engravingFocus = document.querySelector('.alt-engraving__input-field') as HTMLElement | null;
        if (engravingFocus) {
            engravingFocus.classList.add('focused');
        }
    };

    const blurInput = () => {
        const engravingFocus = document.querySelector('.alt-engraving__input-field') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        if (engravingFocus && valueInput) {
            if (!valueInput.value) {
                engravingFocus.classList.remove('focused');
            }
        }
    };

    const changeValueInput = () => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const currentFontElement = document.querySelector('.alt-engraving__fonts span.active') as HTMLElement | null;
        if (valueInput && currentFontElement) {
            const currentFont = currentFontElement.getAttribute('data-font') || '';
            const maxLength = parseInt(validate[currentFont] || '0');
            const inputVal = valueInput.value;
            if (inputVal) {

                if (inputVal.length > maxLength) {
                    const newVal = inputVal.slice(0, maxLength);
                    valueInput.value = newVal;
                    previewContent.value = newVal;
                } else {
                    previewContent.value = inputVal;
                }
            }else{
                previewContent.value = 'Your Engraving';
            }
            updateLengthSelection()
            validateEngravingBtn();
            countInputCharacters(currentFont);
        }
    };

    const selectFonts = (index: string) => {
        selectedFont.value = index;
        
        
        const maxLength = parseInt(validate[index] || '0');
        const classFont = document.querySelector('.alt-engraving__modal-preview span') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        
        if (valueInput && classFont) {
            const inputVal = valueInput.value;
            if (inputVal.length > maxLength) {
                const newVal = inputVal.slice(0, maxLength);
                
                valueInput.value = newVal;
                previewContent.value = newVal;
            }
            fontArr.forEach((font) => {
                classFont.classList.remove(font);
                valueInput.classList.remove(font);
            });

            classFont.classList.add(index);
            valueInput.classList.add(index);
            validateEngravingBtn();
            countInputCharacters(index);
            fonts.forEach((font) => {
                if (font.name === index) {
                emit('customiseUpdateFont', font.label);
                }
            });
            
        }
    };

    const insertSymbol = (index: string) => {
        const currentFontElement = document.querySelector('.alt-engraving__fonts span.active') as HTMLElement | null;
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        if (currentFontElement && valueInput) {
            focusInput();
            const inputVal = valueInput.value;
            const selectionStart = valueInput.selectionStart || 0;
            const selectionEnd = valueInput.selectionEnd || 0;
            const currentFont = currentFontElement.getAttribute('data-font') || '';
            const maxLength = parseInt(validate[currentFont] || '0');
            const symbolWithoutZWSP = index.replace(/\u200B/g, '');
            if (inputVal.length < maxLength) {
                const newVal = inputVal.slice(0, selectionStart) + symbolWithoutZWSP + inputVal.slice(selectionEnd);
                if (newVal) {
                    valueInput.value = newVal;
                    previewContent.value = newVal;
                }
                const newCaretPosition = selectionStart + symbolWithoutZWSP.length;
                valueInput.setSelectionRange(newCaretPosition, newCaretPosition);
                valueInput.focus();
            }
            validateEngravingBtn();
            countInputCharacters(currentFont);
            updateLengthSelection()
        }
    };

    const validateEngravingBtn = () => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const confirmBtn = document.querySelector('.alt-engraving__confirm-button') as HTMLElement | null;
        if (valueInput && confirmBtn) {
            const inputVal = valueInput.value;
            if (inputVal) {
                confirmBtn.classList.remove('disabled');
            } else {
                confirmBtn.classList.add('disabled');
            }
        }
    };

    const countInputCharacters = (index: string) => {
        const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
        const maxLength = parseInt(validate[index] || '0');
        if (valueInput) {
            const inputVal = valueInput.value;
            inputValue.value = inputVal
            charactercount.value = `${maxLength - inputVal.length}/${maxLength} characters left`;
        }
    };
    // New functions
    const toggleSymbols = () => {
    showSymbolsPanel.value = !showSymbolsPanel.value
    }

    const hideSymbols = () => {
    showSymbolsPanel.value = false
    }

    // const handleInput = () => {
    //     if (inputValue.value.length > currentMaxLength.value) {
    //         inputValue.value = inputValue.value.slice(0, currentMaxLength.value)
    //     }
    //     updateLengthSelection()
    // }

    const updateLengthSelection = () => {
        const length = inputValue.value.length
        const lengthItems = document.querySelectorAll('.var-length-name li')

        lengthItems.forEach(item => {
            item.classList.remove('selected')
            const key = item.getAttribute('data-key')
            
            if (key) {
            const [min, max] = key.split('-').map(Number)
            if (length >= min && length <= max) {
                item.classList.add('selected')
                // Trigger click event programmatically
                item.click()
            }
            }
        })
    }

    onMounted(() => {
        if(props.value && props.value !== "Write a Name or Blessing"){
            previewContent.value = props.value;
            const valueInput = document.querySelector('.alt-engraving__input') as HTMLInputElement | null;
            const confirmBtn = document.querySelector('.alt-engraving__confirm-button') as HTMLElement | null;
            if (valueInput && confirmBtn){
                valueInput.value = props.value;
                confirmBtn.classList.remove('disabled');
                focusInput()
            }
        }
        const firstFontElement = document.querySelector('.var-font-type li')
        if (firstFontElement) {
            selectedFont.value = firstFontElement.getAttribute('data-key') || 'Allura'
            firstFontElement.classList.add('selected')
        }

        // max-length
        const maxLengthSetting = props.maxlength; // 20
        const lengthElements = document.querySelectorAll('.var-length-name li');

        let maxLength = 0;

        if (lengthElements) {
            lengthElements.forEach(item => {
                const dataKey = item.getAttribute('data-key');

                // Extract the maximum value from ranges like "1-4", "5-9", "10-14"
                const rangeValues = dataKey.split('-').map(Number);
                const rangeMax = Math.max(...rangeValues);
            
                maxLength = Math.max(maxLength, rangeMax);
            });
        }

        // Compare with maxLengthSetting and take the smaller value
        currentMaxLength.value = Math.min(maxLength, maxLengthSetting);


    })

</script>